export const WORKSPACE_NAME_REGEX = /^[a-zA-Z0-9\s]{8,36}$/;

export const PROJECT_KEY_REGEX = /^[A-Z0-9]{2,4}$/;

export const WORKSPACE_HANDLE_REGEX = /^[a-z0-9]{5,20}$/;

export const AVATAR_MAX_SIZE = 1028 * 1028 * 1; // 1MB

export const WORKSPACE_EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]+$/;

export const RESEND_INVITE_ALLOWED_IN_MINUTES = 6 * 60;

export const WORKSPACE_INVITE_EXPIRE_IN_DAYS = 7;

export const WORKSPACE_CREATION_STEPS = Object.freeze({
  BASIC_DETAILS: Symbol('basic_details'),
  URL_HANDLE: Symbol('url_handle'),
  PROFILE_DETAILS: Symbol('profile_details'),
  PROJECT_DETAILS: Symbol('project_details'),
});

export const AVATAR_TYPES = Object.freeze({
  WORKSPACE: Symbol('workspace'),
  WORKSPACE_PROFILE: Symbol('user'),
});

export const URL_HANDLE_AVAILABILITY = Object.freeze({
  AVAILABLE: Symbol('available'),
  UNAVAILABLE: Symbol('not_available'),
});

export const WORKSPACE_SUBSCRIPTION = Object.freeze({
  TRIAL: Symbol('TRIAL'),
  PAID: Symbol('PAID'),
});

export const SUBSCRIPTION_LIMITATIONS = {
  [WORKSPACE_SUBSCRIPTION.TRIAL]: {
    users: 3,
    projects: 3,
  },
};
